export default __webpack_public_path__ + "static/media/share-work.b56d33db.png";